import { Mutex } from 'async-mutex'
import {
    BaseQueryFn,
    FetchArgs,
    fetchBaseQuery,
    FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react'
import { FetchBaseQueryArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query'
import showLoginModal from '../helpers/show-login-modal'
import { tokenStorage } from '../services/token-storage'

const mutex = new Mutex()

export const getCustomFetchBase = (settings: FetchBaseQueryArgs) => {
    const baseQuery = fetchBaseQuery({
        ...settings,
        credentials: 'include',
        prepareHeaders: headers => {
            const token = tokenStorage.get()

            // debugger

            if (token) headers.set('authorization', `Bearer ${token}`)

            return headers
        },
    })

    const customFetchBase: BaseQueryFn<
        string | FetchArgs,
        unknown,
        FetchBaseQueryError,
        {},
        FetchBaseQueryMeta
    > = async (args, api, extraOptions) => {
        // Ждем, пока mutex станет доступным.
        // Функция может быть вызвана несколько раз,
        // мы блокируем mutex ниже, если идет повторная авторизация,
        // другие запросы в это время ждут, пока произойдет повторная авторизация.
        // Когда повторная авторизация произошла выполнение других запросов продолжится
        // и для них уже будет актуальная сессия
        await mutex.waitForUnlock()
        let result = await baseQuery(args, api, extraOptions)
        const meta = result.meta

        // TODO: Нужно как то отличать "Нет доступа" от "Не залогинен"
        if (meta?.response?.status === 403) {
            //  Проверяем если mutex не заблокирован
            if (!mutex.isLocked()) {
                const release = await mutex.acquire()
                // Ждем пока залогинится
                await new Promise<void>(resolve => showLoginModal(resolve))
                // Перевыполняем оригинальный запрос
                result = await baseQuery(args, api, extraOptions)
                release()
            } else {
                // Если заблокирован, то ждем когда разблокируется и повторяем запрос
                // этот кусок выполняется, если прилетел еще запрос и его тоже редиректнуло на логин,
                // а mutex уже ждет когда повторно авторизуются
                await mutex.waitForUnlock()
                result = await baseQuery(args, api, extraOptions)
            }
        }

        return result
    }

    return customFetchBase
}

export default getCustomFetchBase
